import {Platform} from 'react-native';

// On web, BUILD_VERSION is injected by webpack DefinePlugin at build time.
// On native, we fall back to the package.json version.
function getAppVersion(): string {
  if (Platform.OS === 'web') {
    return process.env.BUILD_VERSION || 'dev';
  }
  // On native, read from the native app build config
  try {
    // react-native-device-info could be used here, but to avoid an extra
    // dependency we read from the build-time injected package.json version.
    return require('../../package.json').version;
  } catch {
    return 'dev';
  }
}

export const APP_VERSION = getAppVersion();
